module.exports = __webpack_public_path__ + "img/977.c70ad33b.png";